import { bool, func, string } from 'prop-types';
import { ModalStyled, ModalActionsStyled, TextStyled, ButtonStyled } from '@nike/nike-design-system-components';

import Spinner from '../../../components/spinner/Spinner';

const ConfirmResubmitModal = ({ isOpen, closeModal, onConfirm, orderId, requestInProgress }) => {
  return (
    <ModalStyled isOpen={isOpen} closeModal={closeModal} title='Confirm Resubmit'>
      <TextStyled appearance='body2'>Are you sure you want to resubmit this order?</TextStyled>
      {requestInProgress && (
        <div style={{ position: 'relative', zIndex: 2, top: '20px' }}>
          <Spinner className='relative-container' />
        </div>
      )}
      <ModalActionsStyled>
        <ButtonStyled
          type='button'
          appearance='primary'
          disabled={requestInProgress}
          onClick={() => onConfirm(orderId)}
        >
          Resubmit
        </ButtonStyled>
        <ButtonStyled type='button' appearance='secondary' disabled={requestInProgress} onClick={closeModal}>
          Cancel
        </ButtonStyled>
      </ModalActionsStyled>
    </ModalStyled>
  );
};

ConfirmResubmitModal.propTypes = {
  isOpen: bool.isRequired,
  closeModal: func.isRequired,
  onConfirm: func.isRequired,
  orderId: string.isRequired,
  requestInProgress: bool.isRequired
};

export default ConfirmResubmitModal;
